import type {DecorationPlugin} from '../../types'
import {pack} from './pack'

export const nicknamesPlugin = {
    name: 'NicknamesPlugin',
    pack
} satisfies DecorationPlugin
